if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        if (this.classList.contains('sticky-atc-form')) return;

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('[data-mc-atc-label]') || this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        if (this.classList.contains('sticky-atc-form')) return;
        window.mcDelivery?.update(this);
        this.closest('product-info')?.syncPurchaseState?.();
      }

      notifyPurchaseState() {
        this.dispatchEvent(new CustomEvent('mc:purchase-state', { bubbles: true }));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitting || this.submitButton.disabled || this.variantIdInput.disabled || this.submitButton.getAttribute('aria-disabled') === 'true' || this.closest('product-info')?.purchaseBlocked) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        this.submitting = true;
        this.submitButton.disabled = true;
        this.notifyPurchaseState();
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        // R2-14: popup from page data in the click frame; cart/add and its events stay as before.
        const previewToken = this.showAddPreview(formData);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              window.mcAtcPopup?.fail?.(previewToken, response.description || response.message || window.cartStrings.error);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (window.giftAuto) {
                const giftId = window.giftProdId;
                const giftInput = this.cart.querySelector('input[data-gift-id="' + giftId + '"]');
                if (giftInput) {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.addGiftItem(giftId);
                  });
                } else {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(response);
                  });
                }
              } else {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              }
            }
          })
          .catch((e) => {
            this.handleErrorMessage(window.cartStrings.error);
            window.mcAtcPopup?.fail?.(previewToken, window.cartStrings.error);
          })
          .finally(() => {
            window.mcAtcPopup?.settle?.(previewToken);
            this.submitting = false;
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            const info = this.closest('product-info');
            if (info?.syncPurchaseState) info.syncPurchaseState();
            else this.toggleSubmitButton(!!this.error);
            this.notifyPurchaseState();
            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      // Only for the cart-notification path, which confirms through mcAtcPopup.show().
      showAddPreview(formData) {
        if (!window.mcAtcPopup?.preview || this.cart?.tagName !== 'CART-NOTIFICATION' || this.closest('quick-add-modal')) return 0;
        try {
          const item = this.closest('product-info')?.getAddPreviewItem?.(formData.get('id'), Number(formData.get('quantity')) || 1);
          return item ? window.mcAtcPopup.preview(item, document.activeElement) : 0;
        } catch (error) {
          // The add itself must never depend on the preview.
          console.warn('ATC preview failed', error);
          return 0;
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
        this.notifyPurchaseState();
      }

      toggleSubmitButton(disable = true, text) {
        disable = !!(disable || this.submitting || this.closest('product-info')?.purchaseBlocked);
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
        this.submitButton.setAttribute('aria-disabled', String(disable));
        this.notifyPurchaseState();
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

if (!customElements.get('product-sticky-atc-button')) {
  customElements.define('product-sticky-atc-button', class ProductStickyAtcButton extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.info = this.closest('product-info');
      this.main = this.info?.querySelector('product-form:not(.sticky-atc-form)');
      this.button = this.querySelector('button[name="add"]');
      this.form = this.querySelector('form');
      if (!this.main || !this.button || !this.form) return;
      this.classList.remove('atc-active', 'is-hidden');
      this.sync = () => this.syncFromMain();
      this.submit = event => {
        event.preventDefault();
        event.stopPropagation();
        this.syncFromMain();
        const button = this.main.submitButton;
        if (!button || this.button.disabled || button.disabled || button.getAttribute('aria-disabled') === 'true' || this.info.purchaseBlocked) return;
        this.main.form.requestSubmit(button);
      };
      this.info.addEventListener('mc:purchase-state', this.sync);
      this.form.addEventListener('submit', this.submit);
      this.syncFromMain();
      const mainButton = this.main.querySelector('button[name="add"]');
      if (!mainButton || !('IntersectionObserver' in window)) return;
      const header = document.querySelector('sticky-header, sticky-simple-header, header.header');
      const height = Math.round(header?.getBoundingClientRect().height || 0);
      this.buttonObserver = new IntersectionObserver(entries => {
        if (!this.isConnected) return;
        const entry = entries[0];
        this.classList.toggle('atc-active', !entry.isIntersecting && entry.boundingClientRect.bottom <= (entry.rootBounds?.top || 0));
      }, { threshold: 0, rootMargin: -height + 'px 0px 0px 0px' });
      this.buttonObserver.observe(mainButton);
      const footer = document.querySelector('.footer, footer, [class*="footer-group"]');
      if (footer) {
        this.footerObserver = new IntersectionObserver(entries => {
          if (this.isConnected) this.classList.toggle('is-hidden', entries[0].isIntersecting);
        }, { threshold: 0.05 });
        this.footerObserver.observe(footer);
      }
    }

    disconnectedCallback() {
      this.info?.removeEventListener('mc:purchase-state', this.sync);
      this.form?.removeEventListener('submit', this.submit);
      this.buttonObserver?.disconnect();
      this.footerObserver?.disconnect();
      this.buttonObserver = this.footerObserver = null;
      this.info = this.main = this.button = this.form = null;
      this.sync = this.submit = null;
    }

    syncFromMain() {
      const mainButton = this.main?.querySelector('button[name="add"]');
      if (!mainButton) return;
      const disabled = !!(mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true' || mainButton.classList.contains('loading') || this.info.purchaseBlocked);
      this.button.disabled = disabled;
      this.button.setAttribute('aria-disabled', String(disabled));
      this.button.classList.toggle('loading', mainButton.classList.contains('loading'));
      this.querySelector('.loading__spinner')?.classList.toggle('hidden', !mainButton.classList.contains('loading'));
      const input = this.querySelector('input[name="id"]');
      input.value = this.main.querySelector('input[name="id"]')?.value || '';
      input.disabled = disabled;
      const selected = this.querySelector('[data-mc-sticky-options]');
      if (selected) selected.textContent = this.info.confirmedVariant?.options?.join(' · ') || '';
      const label = this.querySelector('[data-mc-atc-label]');
      if (label) label.textContent = this.main.submitButtonText?.textContent || window.variantStrings.addToCart;
      const error = this.main.querySelector('.product-form__error-message-wrapper');
      const target = this.querySelector('.product-form__error-message-wrapper');
      if (target) {
        target.hidden = !error || error.hidden;
        target.querySelector('.product-form__error-message').textContent = error?.querySelector('.product-form__error-message')?.textContent || '';
      }
    }
  });
}

if (!customElements.get('size-chart-modal')) {
class SizeChartModal extends ModalDialog {
  constructor() {
    super();


  }
}

customElements.define('size-chart-modal', SizeChartModal);
}

if (!customElements.get('copy-discount-code')) {
class CopyDiscountCode extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('.copy-discount-code__button');
    this.discountCodeText = this.querySelector('.copy-discount-code__button-text');

    if (this.button) {
      this.button.addEventListener('click', this.copyToClipboard.bind(this));
    }
  }

  copyToClipboard() {
    if (!this.discountCodeText) return;

    const discountCode = this.discountCodeText.textContent.trim();

    navigator.clipboard.writeText(discountCode)
      .then(() => {
        // Provide feedback to the user (optional)
        this.showFeedback();
      })
      .catch((error) => {
        console.error('Failed to copy text: ', error);
        this.showFeedback('Failed to copy the discount code.');
      });
  }

  showFeedback() {
    const originalText = this.discountCodeText.textContent.trim();
    const successText = this.button.getAttribute('data-success-text');

    this.discountCodeText.textContent = successText;

    setTimeout(() => {
      this.discountCodeText.textContent = originalText;
    }, 2000);
  }
}

customElements.define('copy-discount-code', CopyDiscountCode);}
